import React, { useEffect, useState } from 'react';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import Select from 'react-select';
import { states } from '../../../utils/Constants';
import FormFaqAccordion from '../formFaqAccordion/formFaqAccordion';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: state.isFocused ? '0px 0px 0px 1px #447b75' : `none`,
    padding: '0px 10px',
    border: '1px solid #333333',
    '&:hover': {
      boxShadow: state.isFocused ? '0px 0px 0px 1px #447b75' : `none`,
    },
  }),
  option: (provided, state) => ({
    padding: '10px 15px',
    background: state.isFocused
      ? 'rgba(138, 219, 209, 0.09)'
      : state.isSelected
      ? 'rgba(138, 219, 209, 0.09)'
      : `white`,
    color: `black`,
  }),
};

const Question2 = props => {
  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        {props.errorState ? (
          <h2 className={`${styles.pageBlock}`}>Details of the person who died</h2>
        ) : null}
        {!props.errorState ? <h3 className={`${styles.pageTitle}`}>Location</h3> : null}
        <h4 className={styles.nswFormLabel}>Where did this person die?</h4>
        <Select
          id="deceasedState"
          onChange={obj => {
            props.setDeceasedState(obj);
          }}
          init
          className={`col-sm-7 col-md-7 col-lg-7 pl-0 mb-5 col-md-10 ${styles.mobileRow}`}
          classNamePrefix={'stateSelect'}
          styles={customStyles}
          value={props.deceasedState}
          placeholder={'Please select'}
          options={states}
        />
        {!props.errorState ? (
          <FormFaqAccordion
            title={`The person died overseas`}
            icon={`Support_troubleshooting.svg`}
            text={`<p>The  Australian Death Notification Service currently doesn't support notifications for people who have died overseas. For overseas deaths you will need to ensure you have a copy of the death certificate and contact organisations you wish to notify independently. </p> <br/><p>View our <a href=\"/participating-organisations\" target=\"_blank\">participating organisations</a> page to view a list of some organisations that may be relevant to you.</p>`}
          ></FormFaqAccordion>
        ) : null}
        {!props.errorState ? (
          <div className={styles.btnWrap}>
            <Button
              disabled={!props.deceasedState}
              onClick={() => {
                props.setCurrentQuestion(3);
              }}
            >
              Next
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Question2;
